import { render } from "./CalendarEventOfferSelectionList.vue?vue&type=template&id=3ef54d95&scoped=true"
import script from "./CalendarEventOfferSelectionList.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOfferSelectionList.vue?vue&type=script&lang=ts"

import "./CalendarEventOfferSelectionList.vue?vue&type=style&index=0&id=3ef54d95&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ef54d95"

export default script